(function () {
  'use strict';
  var data = window.VP_JAR_LABEL_DATA;
  var extras = window.VP_JAR_LABEL_EXTRAS;
  var order = window.VPJarLabelOrder;
  var products = data && Array.isArray(data.products) ? data.products : [];
  var $ = function (id) { return document.getElementById('jl-' + id); };
  // A stale jar-label-order.js or jar-labels.html next to this file (deploy cache skew) shows the fallback.
  if (!products.length || !extras || !order || !order.whiteInks || !order.fiveMlJarType || !order.fulfillmentFor || !order.caseSizeFor || !order.applicationPriceFor || !$('whites') || !$('white-field')) {
    $('load-error').firstChild.textContent = 'Pricing could not load. Please ';
    return;
  }

  var quantityPresets = [20, 50, 100, 200, 300, 500, 1000, 2000, 5000, 10000];
  var quantityPicks = [50, 100, 200, 500, 1000];
  // Quantity choices in whole cases: each old step becomes the nearest case count
  // (rounded up at the discount breaks so they still earn the discount).
  function caseLadder(size, productId) {
    if (!size) return quantityPresets;
    var rule = extras.rules[productId];
    var breaks = rule.discounts.map(function (band) { return band.min; });
    var prev = 0;
    return quantityPresets.map(function (preset) {
      var cases = breaks.indexOf(preset) !== -1 ? Math.ceil(preset / size) : Math.round(preset / size);
      prev = Math.max(cases, Math.ceil(rule.min / size), prev + 1);
      return prev * size;
    });
  }
  function presetsFor(target) { return caseLadder(order.caseSizeFor(target), target.productId); }
  // Index of a quantity in any jar's ladder, so a picked step carries across jars and jar types.
  function presetIndex(qty, productId) {
    var found = -1;
    [0, 30, 32, 90, 95].some(function (size) { found = caseLadder(size, productId).indexOf(qty); return found !== -1; });
    return found;
  }
  function qtyAllowed(target) { return order.quantityAllowed(target); }
  // Josh 10/11: cases lock only when jars are bought. A quantity rounded up to whole cases (as is when labels only).
  function wholeCases(target, qty) { var size = order.caseSizeFor(target); return size ? Math.ceil(qty / size) * size : qty; }
  var quantityOpen = false;
  var storageKey = 'vp_jar_label_choices_v2';
  var choices = Object.create(null);
  var files = Object.create(null);
  var artworkViewed = new Set();
  var state;
  var busy = false;
  var editId = null;
  var editOriginal = null;
  var editBlocked = false;
  var restoreSerial = 0;
  var money = function (cents) { return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100); };
  var unique = function (values) { return Array.from(new Set(values)); };
  var tierName = jarLabelTierName;
  var jarNames = {'miron-5ml-ceres': 'Miron 5ml Ceres', 'miron-5ml-eris': 'Miron 5ml Eris (Child Resistant Lid)', 'black-4oz': '4oz flower jar', 'miron-150ml': 'Miron 150ml'};
  // Fixed renders of each jar with the same VINYLPAC sample art; the live 3D view never replaces them.
  var jarThumbs = {'miron-5ml-ceres': (window.VP_CDN+"jar-labels__strip-miron-5ml-ceres.jpg?v=d8cd36ffb1"), 'miron-5ml-eris': (window.VP_CDN+"jar-labels__strip-miron-5ml-eris.jpg?v=55ec78013e"), 'black-4oz': (window.VP_CDN+"jar-labels__strip-black-4oz.jpg?v=e2805d9772"), 'miron-150ml': (window.VP_CDN+"jar-labels__strip-miron-150ml.jpg?v=ad4411cabe")};
  // Josh 10/17: the 5ml labels are two products (Ceres, Eris: different dies); each fixes its jar type.
  function isFiveMl(id) { return !!order.fiveMlJarType(id); }
  var pieceNames = {body: 'wrap', lid: 'top', ring: 'lid wrap'};
  var pieceLabels = {body: 'Wrap', lid: 'Top', ring: 'Lid wrap'};
  // Josh 10/26 (order #4200: the top could not be added after the wrap): the one upload box takes every file of the
  // set. Which label a file is for comes from its name, else the first open spot: wrap, top, then lid wrap.
  function piecesFor(id) { return hasLidWrap(id) ? ['body', 'lid', 'ring'] : ['body', 'lid']; }
  function guessPiece(name, pieces) {
    var n = String(name || '').toLowerCase().replace(/\.[a-z0-9]+$/, '');
    var word = function (words) { return new RegExp('(^|[^a-z])(' + words + ')([^a-z]|$)').test(n); };  // whole words only (Sol 10/26: "background" is not "round")
    var ring = pieces.indexOf('ring') !== -1 && (/(^|[^a-z])lid[\s_.-]*wrap([^a-z]|$)/.test(n) || word('ring|band|collar'));  // "solid-wrap" is a wrap
    if (ring) return 'ring';
    var lid = word('top|lid|cap|circle|round'), body = word('wrap|side|body');
    if (lid && !body) return 'lid';
    if (body && !lid) return 'body';
    return '';  // no hint, or both: the first open spot
  }
  function pieceTaken(art, piece) { return !!(art[piece] && (art[piece].original || art[piece].reading)); }
  // Sol 10/26: a file still being read must hold Add to cart, or the line is saved without it.
  function anyReading() { var art = artworkFor(state.productId); return ['body', 'lid', 'ring'].some(function (piece) { return !!(art[piece] && art[piece].reading); }); }
  // Where a new file goes: {piece} or {error}. A file named for a piece takes that piece; if a differently named file
  // already sits there it is an error (nothing moves or is replaced unseen: Sol 10/26); a file named for the same piece
  // replaces it (a revised wrap stays the wrap). Unnamed files take the first open spot: wrap, top, then lid wrap.
  function slotFor(name, art, pieces) {
    var guess = guessPiece(name, pieces);
    var taken = function () { return name + ': all ' + pieces.length + ' spots are taken (' + pieces.map(function (p) { return pieceNames[p]; }).join(', ') + '). Remove a file first.'; };
    if (!guess) {
      var open = pieces.filter(function (piece) { return !pieceTaken(art, piece); });
      return open.length ? {piece: open[0]} : {error: taken()};
    }
    if (!pieceTaken(art, guess) || guessPiece(art[guess].name, pieces) === guess) return {piece: guess};
    return {error: name + ': the ' + pieceNames[guess] + ' spot already holds ' + art[guess].name + '. Remove that file, or tap its ' + pieceLabels[guess] + ' tag to move it, then add this one.'};
  }
  var artKeys = {body: ['artworkUrl', 'artworkOriginalUrl'], lid: ['lidArtworkUrl', 'lidArtworkOriginalUrl'], ring: ['ringArtworkUrl', 'ringArtworkOriginalUrl']};
  // White ink (metallic films only): Spot white = white under the colours; No white = colours straight on the film.
  var whiteInks = order.whiteInks;
  // Josh 10/10: metallic films print with no white by default; the underbase is an add-on.
  var NO_WHITE = 'No white';
  function isMetallic(finish) { return order.whiteInkFinishes.indexOf(finish) !== -1; }
  var SHEENS = ['Gloss', 'Matte'];
  function isFlower(id) { return id === 'black-4oz' || id === 'miron-150ml'; }
  // Lid wrap: 150ml and 4oz (Josh 10/15).
  function hasLidWrap(id) { return isFlower(id); }
  // Josh 10/15: both open at the base price, the jar's intro (page load or a jar click) shows the Lid wrap on, and as
  // the lid screws shut the switch flips on with its upcharge in green. A customer's own flip of the switch sticks.
  function ringAuto(target) { return hasLidWrap(target.productId) && !target.ringChosen && !target.ring; }
  var LID_CLOSED_AT = 2.55;  // jar-preview-3d.js intro: INTRO_HOLD 0.35 s + LID_SECONDS 2.2 s

  function productFor(id) { return products.find(function (product) { return product.id === id; }); }
  function makeButton(className, label, action) {
    var button = document.createElement('button');
    button.type = 'button'; button.className = className; button.textContent = label;
    button.addEventListener('click', function () { if (!busy) action(); });
    return button;
  }
  function message(id, text) { $(id).textContent = text; $(id).hidden = !text; }
  function defaults(product) {
    var variant = product.variants[0];
    return {productId: product.id, tier: variant.options[0], finish: variant.options[1], emboss: variant.options[2], qty: 50, qtyCustom: false, addJars: false, application: false, jarType: '', jarTypeDetails: '', ring: false, ringChosen: false, notes: '', embossWords: '', image: 0, view: 'photos', whiteInk: NO_WHITE};
  }
  // "What should we emboss?" (Josh 10/31): the words ride into the order as the first line of Special Instructions
  // ("Emboss: …"), so the cart, checkout and Command read them where they always have.
  // Sol 10/31: the words go only with an embossed finish (a Flat line carries none), on ONE line (so Edit gets them
  // all back), and the joined text stays under the checkout's 1,000-character note limit (NOTES_MAX), else Add to
  // cart says so instead of the checkout dropping the whole note.
  var NOTES_MAX = 1000;
  function embossOn(s) { return (s.emboss || '') !== 'No Embossing'; }
  function joinNotes(s) {
    var words = embossOn(s) ? (s.embossWords || '').replace(/\s*\n\s*/g, ' ').trim() : '', notes = (s.notes || '').trim();
    return words ? 'Emboss: ' + words + (notes ? '\n' + notes : '') : notes;
  }
  // Only an embossed line has a box line to split off (Sol r2: a Flat line whose customer typed "Emboss: none; …"
  // themselves keeps every word in Special instructions).
  function splitNotes(text, c) {
    var lines = String(text || '').split('\n');
    if (c && !embossOn(c)) return {embossWords: '', notes: String(text || '')};
    if (/^Emboss: /.test(lines[0])) return {embossWords: lines[0].slice(8).trim(), notes: lines.slice(1).join('\n').trim()};
    return {embossWords: '', notes: String(text || '')};
  }
  function normalizeOptions(target) {
    var product = productFor(target.productId);
    var tiers = unique(product.variants.map(function (v) { return v.options[0]; }));
    if (tiers.indexOf(target.tier) === -1) target.tier = tiers[0];
    var candidates = product.variants.filter(function (v) { return v.options[0] === target.tier; });
    var finishes = unique(candidates.map(function (v) { return v.options[1]; }));
    // Josh 10/17: flat Standard is two materials, Gloss and Matte; an emboss tier keeps Standard and carries
    // the same choice as its emboss finish, so switching tiers keeps the buyer's sheen.
    if (finishes.indexOf(target.finish) === -1) {
      var sheen = SHEENS.indexOf(target.finish) !== -1 ? target.finish : target.finish === 'Standard' && SHEENS.indexOf(target.emboss) !== -1 ? target.emboss : '';
      if (sheen && finishes.indexOf(sheen) !== -1) target.finish = sheen;
      else if (sheen && finishes.indexOf('Standard') !== -1) { target.finish = 'Standard'; target.emboss = sheen; }
      else target.finish = finishes[0];
    }
    var embosses = unique(candidates.filter(function (v) { return v.options[1] === target.finish; }).map(function (v) { return v.options[2]; }));
    if (embosses.indexOf(target.emboss) === -1) target.emboss = embosses[0];
    if (!hasLidWrap(target.productId)) target.ring = false;
    // Josh 10/15: same Jar options on every jar; the 5ml adds glass by jar type and never application.
    if (!isFlower(target.productId)) target.application = false;
    if (target.application) target.addJars = true;
    // Josh 10/15: no "Other" 5ml jar; a different jar orders through the labels page.
    target.jarType = order.fiveMlJarType(target.productId);
    if (whiteInks.indexOf(target.whiteInk) === -1) target.whiteInk = NO_WHITE;
    return {tiers: tiers, finishes: finishes, embosses: embosses};
  }
  function artworkFor(id) { return files[id] || (files[id] = {}); }
  function currentVariant() {
    return productFor(state.productId).variants.find(function (v) {
      return v.options[0] === state.tier && v.options[1] === state.finish && v.options[2] === state.emboss;
    });
  }
  function configuration() {
    var art = artworkFor(state.productId);
    var variant = currentVariant();
    var ring = state.ring ? order.ringFor(state) : null;
    var has = function (piece) { return !!(art[piece] && art[piece].original && !art[piece].reading); };
    return {
      version: 1, kind: 'jar-labels', productId: state.productId,
      variantId: variant ? variant.id : '', tier: state.tier, finish: state.finish, emboss: state.emboss,
      whiteInk: isMetallic(state.finish) ? state.whiteInk : '',
      qty: state.qty, addJars: state.addJars === true, application: state.application === true, jarType: state.jarType,
      jarTypeDetails: '',
      lidWrap: state.ring ? {variantId: ring ? ring.variantId : '', priceCents: ring ? ring.priceCents : 0} : null,
      notes: joinNotes(state), bodyFilename: has('body') ? art.body.name : '', lidFilename: has('lid') ? art.lid.name : '',
      ringFilename: state.ring && has('ring') ? art.ring.name : '',
      artwork: {body: has('body'), lid: has('lid'), ring: state.ring && has('ring'), bodyOriginal: has('body'), lidOriginal: has('lid'), ringOriginal: state.ring && has('ring')}
    };
  }
  function syncMetadata() {
    var product = productFor(state.productId);
    var title = product.name + ' — VINYLPAC';
    var jar = product.id === 'black-4oz' ? '4oz black glass' : jarNames[product.id];
    var description = 'Custom top stickers and ' + (isFiveMl(product.id) ? 'perforated ' : '') + 'wrap labels for ' + jar + ' jars. Choose your material and embossing, with optional artwork upload.';
    var url = 'https://vinylpac.us/?view=jar-labels&jar=' + encodeURIComponent(product.id);
    document.title = title;
    [['meta[name="description"]', 'content', description],
      ['meta[property="og:title"]', 'content', title],
      ['meta[property="og:description"]', 'content', description],
      ['meta[property="og:url"]', 'content', url],
      ['link[rel="canonical"]', 'href', url]].forEach(function (entry) {
      var node = document.querySelector(entry[0]);
      if (node) node.setAttribute(entry[1], entry[2]);
    });
  }
  function persist() {
    syncMetadata();
    try { sessionStorage.setItem(storageKey, JSON.stringify({active: state.productId, choices: choices, lidWrapChosen: true})); }
    catch (_) { /* Cart persistence has its own blocking error path. */ }
    var url = new URL(location.href);
    url.searchParams.set('jar', state.productId);
    ['tier', 'finish', 'emboss', 'qty'].forEach(function (key) {
      if (state[key] !== '' && state[key] !== null) url.searchParams.set(key, String(state[key])); else url.searchParams.delete(key);
    });
    url.searchParams.delete('jarType'); url.searchParams.delete('jarTypeDetails');  // the 5ml product names its jar
    if (isMetallic(state.finish)) url.searchParams.set('whiteInk', state.whiteInk); else url.searchParams.delete('whiteInk');
    // Lid wrap: only the customer's own choice goes in the link (the intro's flip replays on every visit).
    url.searchParams.delete('ring');
    if (hasLidWrap(state.productId) && state.ringChosen) url.searchParams.set('lidWrap', state.ring ? '1' : '0'); else url.searchParams.delete('lidWrap');
    ['addJars', 'application'].forEach(function (key) {
      if (key === 'addJars' || isFlower(state.productId)) url.searchParams.set(key, state[key] ? '1' : '0'); else url.searchParams.delete(key);
    });
    var variant = currentVariant();
    if (variant) url.searchParams.set('variant', variant.id);
    if (editId) url.searchParams.set('edit', editId); else url.searchParams.delete('edit');
    if (url.href !== location.href) history.replaceState(null, '', url);
  }
  function notifyJarPreview() {
    if (window.vpJarBuilderPreview) window.vpJarBuilderPreview.syncLabels();
  }
  function changed(optionsChanged) {
    message('save-error', ''); message('saved', ''); $('review').hidden = true;
    if (optionsChanged) renderOptions(); else renderPrice();
    notifyJarPreview();
  }
  function setGallery(view) {
    state.view = view === 'artwork' ? 'artwork' : 'photos';
    if (state.view === 'artwork') artworkViewed.add(state.productId);
    $('photo-view').hidden = state.view !== 'photos';
    $('artwork-view').hidden = state.view !== 'artwork';
    $('gallery-views').querySelectorAll('button').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.view === state.view));
    });
    syncArtworkTabs();
    persist();
    notifyJarPreview();
  }
  function selectImage() {
    var product = productFor(state.productId);
    // 10/12 Josh: the 150ml stage never shows a client's jar. Its images are VINYLPAC sample renders (sample: true,
    // drawn like the live stage instead of multiplied into the grey photo box) and follow the Lid wrap choice.
    var index = 0;
    product.images.some(function (image, i) {
      if (typeof image.lidWrap !== 'boolean' || image.lidWrap === (!!state.ring || ringAuto(state))) { index = i; return true; }
      return false;
    });
    var image = product.images[index];
    if (!image) return;
    state.image = index;
    $('main-image').setAttribute('src', image.src);
    $('main-image').alt = image.alt;
    $('main-image').classList.toggle('jl-sample', image.sample === true);
    persist();
  }
  // Preview only: cart artworkRecord() always serializes the untouched original, never this PNG.
  async function renderPdfPreview(original, isCurrent) {
    var task, canvas;
    try {
      if (!window.pdfjsLib && window.vpLazy) await window.vpLazy('pdfjs');
      if (!window.pdfjsLib || !isCurrent()) return null;
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      task = window.pdfjsLib.getDocument(original);
      var pdf = await task.promise;
      if (!isCurrent()) return null;
      var page = await pdf.getPage(1);
      if (!isCurrent()) return null;
      var size = page.getViewport({scale: 1});
      // Bound phone memory even when a print PDF has a very large page.
      var viewport = page.getViewport({scale: Math.min(1.5, 1800 / Math.max(size.width, size.height))});
      canvas = document.createElement('canvas');
      canvas.width = Math.ceil(viewport.width); canvas.height = Math.ceil(viewport.height);
      await page.render({canvasContext: canvas.getContext('2d'), viewport: viewport}).promise;
      return isCurrent() ? canvas.toDataURL('image/png') : null;
    } catch (_) { return null; }
    finally {
      if (canvas) { canvas.width = 0; canvas.height = 0; }
      if (task) { try { await task.destroy(); } catch (_) { /* Original remains ready to order. */ } }
    }
  }
  function cancelArtworkPreview(file) {
    if (!file || file.previewStatus !== 'loading') return;
    // A failed replacement may restore this same file object. Give it a fresh render then.
    delete file.previewRun;
    delete file.previewStatus;
  }
  // Josh 10/17: any file type. AI, PSD and other files the browser can't show as they are get a preview from
  // art-files.js (or its file card); the original is what goes to the order either way.
  function renderFilePreview(file, isCurrent) {
    var m = /^data:([^;,]+);base64,(.*)$/.exec(file.original || '');
    if (!m || !window.VPArtFiles) return Promise.resolve(null);
    var bin = atob(m[2]), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    var blob = new File([bytes], file.name || 'artwork', {type: m[1]});
    return window.VPArtFiles.preview(blob, 1800).then(function (url) { return isCurrent() ? url : null; });
  }
  function prepareArtworkPreview(productId, piece, file) {
    if (!file || !file.original || file.previewStatus || isWebImage(file.original)) return;
    var pdf = /^data:application\/pdf[;,]/.test(file.original);
    var art = artworkFor(productId);
    var run = {};
    file.previewRun = run;
    var isCurrent = function () { return file.previewRun === run && files[productId] === art && art[piece] === file; };
    file.previewStatus = 'loading';
    (pdf ? renderPdfPreview(file.original, isCurrent) : renderFilePreview(file, isCurrent)).then(function (preview) {
      if (!isCurrent()) return;  // Removed, replaced, or a different cart item was restored.
      delete file.previewRun;
      file.preview = preview;
      file.previewStatus = preview ? 'ready' : 'unavailable';
      // An inactive jar may keep its own preview; it must never repaint the selected jar's panel.
      if (state.productId === productId) renderArtwork();
    });
  }
  function renderArtwork() {
    var art = artworkFor(state.productId);
    var pieces = piecesFor(state.productId);
    ['body', 'lid', 'ring'].forEach(function (piece) {
      var file = pieces.indexOf(piece) !== -1 ? art[piece] : null;
      var flat = document.querySelector('#jl-artwork-view [data-piece="' + piece + '"]');
      if (flat) flat.hidden = piece !== 'body' && !file;  // the wrap panel always shows (it carries the empty note)
      prepareArtworkPreview(state.productId, piece, file);
      var source = file && (file.preview || (isWebImage(file.original) ? file.original : ''));
      var preview = $(piece + '-preview');
      preview.hidden = !source;
      if (!preview.hidden) {
        if (preview.getAttribute('src') !== source) preview.src = source;
      } else preview.removeAttribute('src');
      $(piece + '-preview-note').hidden = !preview.hidden;
      $(piece + '-preview-note').textContent = file && file.original ? (file.previewStatus === 'loading' ? 'Rendering preview… Original file retained.' : file.name + ' — original retained; no flat preview for this file.') : 'Add your artwork to see it here.';
    });
    renderFileList(art, pieces);
    syncArtworkTabs();
  }
  // One row per file under the box: its label (tap to change), its name, Remove.
  function renderFileList(art, pieces) {
    var list = $('files');
    list.replaceChildren();
    var missing = [];
    pieces.forEach(function (piece) {
      var file = art[piece];
      if (!file) { if (piece !== 'ring' || state.ring) missing.push(pieceNames[piece]); return; }
      var row = document.createElement('li');
      var tag = makeButton('jl-file-piece', pieceLabels[piece], function () { cyclePiece(piece); });
      tag.title = 'Change which label this file is for';
      tag.setAttribute('aria-label', pieceLabels[piece] + ' file ' + file.name + '. Change which label it is for');
      var name = document.createElement('span');
      name.className = 'jl-file-name';
      name.textContent = file.name + (file.reading ? ' · reading…' : '');
      if (piece === 'ring' && !state.ring) {
        var note = document.createElement('small');
        note.textContent = 'Turn on Lid wrap above to include this file.';
        name.appendChild(note);
      }
      var remove = makeButton('jl-file-remove', 'Remove', function () { removeFile(piece); });
      remove.setAttribute('aria-label', 'Remove ' + file.name);
      row.append(tag, name, remove);
      list.appendChild(row);
    });
    var count = pieces.filter(function (piece) { return art[piece]; }).length;
    $('body-filename').textContent = !count ? 'No files selected' : missing.length ? 'Add your ' + missing.join(' and ') + ' too, or add to cart now.' : 'All files ready.';
  }
  // Josh 10/15: one optional upload field for the whole set (no Wrap / Top / Lid wrap tabs); 10/26: it takes every file.
  function syncArtworkTabs() {
    var art = artworkFor(state.productId);
    var count = piecesFor(state.productId).filter(function (piece) { return art[piece] && art[piece].original; }).length;
    $('upload-progress').textContent = count ? count + (count === 1 ? ' file ready' : ' files ready') : 'Optional';
    var canViewArtwork = count > 0 || artworkViewed.has(state.productId);
    document.querySelector('#jl-gallery-views [data-view="artwork"]').hidden = !canViewArtwork;
    $('gallery-views').hidden = !canViewArtwork;
  }
  function buildQuantity() {
    var list = $('qty-list');
    list.replaceChildren();
    var half = Math.ceil(quantityPresets.length / 2);
    var ordered = [];
    for (var index = 0; index < half; index++) {
      ordered.push(index);
      if (index + half < quantityPresets.length) ordered.push(index + half);
    }
    // Preset rows carry their ladder position; renderQuantity fills in the jar's case counts.
    ordered.concat(['custom']).forEach(function (value) {
      var row = document.createElement('label');
      row.className = 'sq-radio-row' + (value === 'custom' ? ' sq-custom-row' : '');
      if (value === 'custom') row.style.setProperty('--sq-peek-order', '999999'); else row.dataset.index = String(value);
      var radio = document.createElement('input');
      radio.type = 'radio'; radio.name = 'jarQuantity'; radio.value = value === 'custom' ? 'custom' : String(quantityPresets[value]);
      radio.addEventListener('change', function () {
        if (busy) return;
        state.qtyCustom = value === 'custom';
        if (!state.qtyCustom) state.qty = Number(radio.value);
        changed(false);
        if (state.qtyCustom) $('qty').focus({preventScroll: true});
      });
      var text = document.createElement('span'); text.className = 'sq-radio-text';
      text.textContent = value === 'custom' ? 'Custom quantity' : '';
      row.append(radio, text);
      if (value === 'custom') {
        var custom = document.createElement('span'); custom.className = 'sq-custom-qty'; custom.id = 'jl-custom-qty';
        var input = document.createElement('input'); input.id = 'jl-qty'; input.type = 'number'; input.min = '20'; input.step = '1'; input.inputMode = 'numeric'; input.placeholder = 'Qty'; input.name = 'quantity';
        input.setAttribute('aria-label', 'Custom number of label sets'); input.setAttribute('aria-describedby', 'jl-qty-error'); input.dataset.qa = 'qty-input';
        var noun = document.createElement('span'); noun.className = 'sq-dims-unit'; noun.textContent = 'sets';
        custom.append(input, noun); row.appendChild(custom);
      } else {
        var badge = document.createElement('span'); badge.className = 'sq-radio-save'; row.appendChild(badge);
      }
      list.appendChild(row);
    });
  }
  function renderQuantity(c, q) {
    var presets = presetsFor(state);
    var custom = state.qtyCustom || presets.indexOf(c.qty) === -1;
    var picks = quantityPicks.map(function (pick) { return presets[quantityPresets.indexOf(pick)]; });
    if (!custom && picks.indexOf(c.qty) === -1) picks[picks.length - 1] = c.qty;
    $('qty-panel').classList.toggle('open', quantityOpen);
    $('qty-trigger').setAttribute('aria-expanded', String(quantityOpen));
    $('qty-trigger').textContent = custom ? (Number.isFinite(c.qty) ? c.qty.toLocaleString('en-US') + ' (custom)' : 'Custom quantity') : c.qty.toLocaleString('en-US') + ' sets' + (q ? ' · ' + money(q.unitCents) + '/set' : '');
    $('custom-qty').hidden = !custom;
    if (document.activeElement !== $('qty')) $('qty').value = Number.isFinite(c.qty) ? c.qty : '';
    $('qty-list').querySelectorAll('.sq-radio-row').forEach(function (row) {
      var radio = row.querySelector('input[type=radio]');
      if (row.dataset.index) {
        var preset = presets[Number(row.dataset.index)];
        radio.value = String(preset);
        row.style.setProperty('--sq-peek-order', String(preset));
        row.querySelector('.sq-radio-text').textContent = preset.toLocaleString('en-US') + ' sets';
      }
      var value = radio.value === 'custom' ? 'custom' : Number(radio.value);
      radio.checked = value === 'custom' ? custom : !custom && value === c.qty;
      row.classList.toggle('sq-pick', value === 'custom' || picks.indexOf(value) !== -1);
      if (value !== 'custom') {
        var badge = row.querySelector('.sq-radio-save');
        var rate = 0; extras.rules[state.productId].discounts.forEach(function (band) { if (value >= band.min) rate = band.rate; });
        badge.hidden = !rate; badge.textContent = rate ? 'save ' + Math.round(rate * 100) + '%' : '';
      }
    });
  }
  function renderVolume() {
    var c = configuration();
    var rule = extras.rules[state.productId];
    var rows = $('volume-rows'); rows.replaceChildren();
    [{min: rule.min, rate: 0}].concat(rule.discounts).forEach(function (band, index, bands) {
      var range = band.min.toLocaleString('en-US') + (bands[index + 1] ? '–' + (bands[index + 1].min - 1).toLocaleString('en-US') : '+');
      var price;
      try { price = money(order.quote(Object.assign({}, c, {qty: band.min, lidWrap: null, addJars: false, application: false})).baseUnitCents); }
      catch (_) { price = 'Unavailable'; }
      var row = document.createElement('tr');
      [range, band.rate ? Math.round(band.rate * 100) + '%' : '—', price].forEach(function (text) { var cell = document.createElement('td'); cell.textContent = text; row.appendChild(cell); });
      rows.appendChild(row);
    });
  }
  // Per-jar label price of each emboss tier at the picked quantity (the minimum until one is valid).
  function tierUnitCents(tier) {
    var product = productFor(state.productId);
    var rule = extras.rules[state.productId];
    var qty = qtyAllowed(state) ? state.qty : presetsFor(state)[0];
    // The finish this tier would get (flat Gloss/Matte ↔ Standard + that emboss finish).
    var probe = Object.assign({}, state, {tier: tier});
    if (tier !== state.tier) normalizeOptions(probe);
    var variant = product.variants.find(function (v) { return v.options[0] === tier && v.options[1] === probe.finish && v.options[2] === probe.emboss; });
    if (!variant) return null;
    var ring = state.ring ? order.ringFor(probe) : null;
    if (state.ring && !ring) return null;
    try {
      var q = order.quote(Object.assign({}, configuration(), {tier: tier, finish: probe.finish, emboss: variant.options[2], variantId: variant.id, qty: qty, addJars: false, application: false, lidWrap: ring ? {variantId: ring.variantId, priceCents: ring.priceCents} : null}));
      return q.baseUnitCents + q.ringUnitCents;
    } catch (_) { return null; }
  }
  function renderDetails() {
    var flat = tierUnitCents('Economical');
    $('tiers').querySelectorAll('button').forEach(function (button) {
      var unit = button.dataset.tier === 'Economical' ? flat : tierUnitCents(button.dataset.tier);
      var small = button.querySelector('small') || button.appendChild(document.createElement('small'));
      small.textContent = button.dataset.tier === 'Economical' ? 'Included' : flat !== null && unit !== null ? '+' + money(unit - flat) + '/set' : 'Unavailable';
    });
    $('extras').hidden = false;
    // Josh 10/15: Jar options always open (no dropdown).
    $('jars-help').hidden = !state.addJars;
    $('application-help').hidden = !state.application;
  }
  function renderPrice() {
    // A picked step follows the jar's cases (e.g. 100 → 96 on 4oz); typed quantities stay as typed.
    if (!state.qtyCustom) {
      var presets = presetsFor(state);
      if (presets.indexOf(state.qty) === -1) {
        var index = presetIndex(state.qty, state.productId);
        if (index !== -1) state.qty = presets[index]; else state.qtyCustom = true;
      }
    }
    var c = configuration();
    var q = null;
    var priceError = '';
    try { q = order.quote(c); } catch (error) { priceError = error.message; }
    var qtyValid = qtyAllowed(c);
    $('qty').setAttribute('aria-invalid', String(c.qty !== null && !qtyValid));
    message('qty-error', c.qty === null || qtyValid ? '' : order.quantityRuleText(c));
    var selectedVariant = currentVariant();
    // Same shape as the sticker builder: per-set price big beside the name,
    // the order total beside Add to Cart (the minimum order until a quantity is picked).
    var fromQuote = null;
    if (!q && selectedVariant) {
      try { fromQuote = order.quote(Object.assign({}, c, {qty: wholeCases(c, extras.rules[state.productId].min)})); } catch (_) {}
    }
    $('total-label').textContent = q ? 'Total' : 'From';
    $('total').textContent = q ? money(q.totalCents) : fromQuote ? money(fromQuote.totalCents) : '—';
    $('price').textContent = q ? money(q.unitCents) : fromQuote ? money(fromQuote.unitCents) : selectedVariant ? money(selectedVariant.price) : '—';
    $('head-price').classList.toggle('is-ready', !!(q || selectedVariant));
    $('discount').textContent = q && q.discountRate ? Math.round(q.discountRate * 100) + '% off top + wrap' : '';
    $('unit-detail').textContent = q ? c.qty.toLocaleString('en-US') + ' label sets · ' + money(q.baseUnitCents + q.ringUnitCents) + '/set' : '';
    var components = q ? [q.jarTotalCents ? q.jarCount.toLocaleString('en-US') + ' glass jars · ' + money(q.jarTotalCents) : '', q.applicationTotalCents ? 'Application on ' + c.qty.toLocaleString('en-US') + ' jars · ' + money(q.applicationTotalCents) : ''].filter(Boolean) : [];
    $('breakdown').textContent = components.join(' · ');
    $('selection').textContent = [c.finish, c.whiteInk, jarLabelEmbossSummary(c.tier, c.emboss)].filter(Boolean).join(' · ');
    var variant = currentVariant();
    if (variant && variant.available && !variant.previewOnly && c.whiteInk !== 'No white') {
      var live = new URL(productFor(state.productId).url); live.searchParams.set('variant', variant.id);
      $('order').href = live.href; $('order').removeAttribute('aria-disabled');
    } else { $('order').removeAttribute('href'); $('order').setAttribute('aria-disabled', 'true'); }
    $('order').textContent = variant && variant.previewOnly ? c.finish + ' is not on the live store yet' : c.whiteInk === 'No white' ? 'No-white printing is not on the live store yet' : 'Order on the live store ↗';
    if (c.addJars || c.application) { $('order').removeAttribute('href'); $('order').setAttribute('aria-disabled', 'true'); $('order').textContent = 'Ready-to-fill options are saved in this preview cart'; }
    var fulfillment = null, fulfillmentError = '', applicationCents = 0;
    try { fulfillment = order.fulfillmentFor(c); applicationCents = order.applicationPriceFor(c); }
    catch (error) { fulfillmentError = error.message; }
    $('fulfillment').hidden = false;
    $('application').closest('label').hidden = !isFlower(c.productId);
    $('add-jars').checked = c.addJars; $('application').checked = c.application;
    var glassQuote = c.addJars ? q : null;
    if (fulfillment && !c.addJars) {
      try { glassQuote = order.quote(Object.assign({}, c, {qty: wholeCases(Object.assign({}, c, {addJars: true}), qtyValid ? c.qty : extras.rules[c.productId].min), addJars: true, application: false})); }
      catch (error) { glassQuote = null; fulfillmentError = error.message; }
    }
    $('add-jars').disabled = busy || ((!fulfillment || !glassQuote) && !c.addJars);
    $('application').disabled = busy || ((!fulfillment || !glassQuote) && !c.application);
    var needsJarType = isFiveMl(c.productId) && !c.jarType;
    $('jars-price').textContent = glassQuote ? '+' + money(glassQuote.jarTotalCents) : needsJarType ? 'Pick your jar first' : 'Unavailable';
    $('application-price').textContent = fulfillment ? '+' + money(applicationCents) + '/jar' : 'Unavailable';
    $('included').textContent = c.addJars ? (c.application ? 'Your labels applied to matching glass jars, ready to fill.' : 'Printed top + wrap with matching glass jars and lids.') : 'Printed top + ' + (isFiveMl(c.productId) ? 'perforated ' : '') + 'wrap. Labels only.';
    var caseWord = isFiveMl(c.productId) ? 'pack' : 'case';
    $('jars-help').textContent = glassQuote ? glassQuote.jarCases + ' ' + caseWord + (glassQuote.jarCases === 1 ? '' : 's') + ' · ' + glassQuote.jarCount.toLocaleString('en-US') + ' jars with lids' : 'Matching glass jars with lids';
    message('fulfillment-note', fulfillmentError || (c.addJars && q && q.spareJars ? q.spareJars.toLocaleString('en-US') + ' spare jars arrive unlabeled. Glass is supplied in full ' + (isFiveMl(c.productId) ? 'packs' : 'cases') + ' of ' + q.jarCaseSize + '.' : ''));
    $('application-help').textContent = c.addJars ? 'Your selected labels applied, ready to fill' : 'Includes the jars; your labels applied, ready to fill';
    var readyError = priceError;
    try { order.validate(c); } catch (error) { readyError = error.message; }
    if (anyReading()) readyError = 'Wait for your original files to finish loading.';
    if (editBlocked) readyError = 'This item could not be restored. Cancel the edit to start a new order.';
    if (!window.VPProductCart) readyError = 'Local cart storage could not load. Reload this page to try again.';
    if (busy) readyError = editOriginal ? 'Saving original files and updating your cart…' : 'Loading or saving your original files…';
    $('ready').textContent = readyError || 'Your labels are ready to add to cart.';
    $('add').disabled = !!readyError || busy;
    // Josh 10/15: no file → "Upload later and add to cart"; with a file → "Add to cart".
    $('add').textContent = busy ? 'Please wait…' : editId ? 'Update cart' : (c.artwork.body || c.artwork.lid || c.artwork.ring) ? 'Add to cart' : 'Upload later and add to cart';
    if (readyError && !busy) {
      var hint = !qtyValid ? 'Enter a valid quantity' : isFiveMl(c.productId) && !c.jarType ? 'Choose your jar type' : 'Complete your selections';
      $('add').dataset.hint = hint;
    } else delete $('add').dataset.hint;
    $('add').title = readyError;
    renderDetails();
    renderVolume();
    renderQuantity(c, q);
    syncArtworkTabs();
    persist();
  }
  function choiceButtons(id, values, selected, key, descriptions) {
    var container = $(id); container.replaceChildren();
    values.forEach(function (value) {
      var button = makeButton('jl-choice', key === 'tier' ? tierName(value) : value, function () {
        state[key] = value; changed(true);
        var selectedButton = Array.from($(id).querySelectorAll('button')).find(function (node) { return node.dataset[key] === value; });
        if (selectedButton) selectedButton.focus({preventScroll: true});
      });
      button.dataset[key] = value;
      button.setAttribute('aria-label', key === 'tier' ? tierName(value) : value);
      button.setAttribute('aria-pressed', String(value === selected));
      if (descriptions && descriptions[value]) { var small = document.createElement('small'); small.textContent = descriptions[value]; button.appendChild(small); }
      container.appendChild(button);
    });
  }
  function renderOptions() {
    var options = normalizeOptions(state);
    choiceButtons('tiers', options.tiers, state.tier, 'tier');
    choiceButtons('finishes', options.finishes, state.finish, 'finish');
    choiceButtons('embosses', options.embosses, state.emboss, 'emboss');
    var underbase = makeButton('jl-choice jl-underbase', '', function () { state.whiteInk = state.whiteInk === 'Spot white' ? NO_WHITE : 'Spot white'; changed(true); });
    underbase.dataset.whiteInk = 'Spot white';
    underbase.setAttribute('aria-pressed', String(state.whiteInk === 'Spot white'));
    var underbaseName = document.createElement('span'); underbaseName.textContent = 'Add white underbase';
    var underbaseNote = document.createElement('small'); underbaseNote.textContent = 'Describe where in Special instructions';
    underbase.append(underbaseName, underbaseNote);
    $('whites').replaceChildren(underbase);
    $('white-field').hidden = !isMetallic(state.finish);
    var flat = options.embosses.length === 1 && options.embosses[0] === 'No Embossing';
    $('emboss-field').hidden = flat; $('emboss-field').disabled = flat;
    $('emboss-ask').hidden = flat;
    var ring = order.ringFor(state);
    $('ring-field').hidden = !hasLidWrap(state.productId);
    $('ring').checked = state.ring;
    $('ring').disabled = busy || ((!ring || !ring.available) && !state.ring);
    $('ring-price').textContent = ring ? '+' + money(ring.priceCents) + ' / jar' + (ring.available ? '' : ' · unavailable') : 'Unavailable for this selection';
    $('ring-price').classList.toggle('jl-upcharge-on', !!state.ring && !!ring);
    if (!state.ring) $('ring-price').classList.remove('jl-upcharge-added');
    // The 3D jar wears the Lid wrap through the intro before the switch flips (jar-builder-preview.js payload).
    $('ring').dataset.preview = ringAuto(state) ? 'on' : '';
    renderArtwork();
    renderPrice();
  }
  function renderProduct(product) {
    state = choices[product.id] || (choices[product.id] = defaults(product));
    if (hasLidWrap(product.id) && !state.ringChosen) state.ring = false;
    normalizeOptions(state);
    $('products').querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.jar === product.id)); });
    $('product-title').textContent = product.name;
    $('builder-title').textContent = product.name;
    $('included').textContent = 'Printed top + ' + (isFiveMl(product.id) ? 'perforated ' : '') + 'wrap. Glass jars not included.';
    $('qty').value = Number.isFinite(state.qty) ? state.qty : '';
    $('notes').value = state.notes;
    $('emboss-words').value = state.embossWords || '';
    $('body-file').value = '';
    selectImage();
    setGallery(state.view);
    renderOptions();
    notifyJarPreview();
    armLidWrap();
    renderTemplates(product);
  }
  // Die line templates under Jar label details: the VINYLPAC jar art as layered PDFs (built 10/18 from
  // V:\VINYLPAC Files\Artwork & Logos\new sticker\Dielines), with Emboss (RDG_GLOSS, clipped to the cut) +
  // White Ink (RDG_WHITE) layers drawn by the live 3D jar's rules and Roland swatches. The artwork is one
  // flattened 300 ppi raster here (vector masters stay in-house). Eris = the straight CR die (the curved one
  // is swapped in-house); 4oz wrap = Skyfall's 9/28 Dante's Inferno cut. [file, piece, page w pt, page h pt, die].
  var TEMPLATES = {
    'miron-5ml-ceres': ['5ml Ceres', [['ceres-wrap', 'Wrap', 331.2, 80.29, '4.5 × 1 in'], ['ceres-top', 'Top', 105.2, 105.2, '1.31 in circle']]],
    'miron-5ml-eris': ['5ml Eris', [['eris-wrap', 'Wrap', 342, 90.76, '4.65 × 1.16 in'], ['eris-top', 'Top', 100.05, 100.12, '1.31 in circle']]],
    'black-4oz': ['4oz', [['4oz-wrap', 'Wrap', 540, 165.6, '7.3 × 2.05 in'], ['4oz-top', 'Top', 165.6, 165.6, '2.2 in circle']]],
    'miron-150ml': ['150ml', [['150ml-wrap', 'Wrap', 522.65, 227.5, '7.08 × 3 in'], ['150ml-lid-wrap', 'Lid wrap', 504.1, 50.46, '6.89 × 0.57 in'], ['150ml-top', 'Top', 144.1, 144.1, '1.85 in circle']]]
  };
  var TEMPLATE_DIR = (window.VP_CDN+"jar-labels__templates__");
  // Shopify's CDN keeps a file per ?v= forever: bump this whenever the template files change.
  var TEMPLATE_V = '?v=20261018-1630';
  function renderTemplates(product) {
    var box = $('templates'), spec = TEMPLATES[product.id];
    if (!box) return;
    box.hidden = !spec;
    if (!spec || box.dataset.jar === product.id) return;
    box.dataset.jar = product.id;
    // Every piece of one jar shares one scale, so the top reads at its real size next to the wrap.
    var widest = Math.max.apply(null, spec[1].map(function (p) { return p[2]; }));
    $('tpl-pieces').replaceChildren.apply($('tpl-pieces'), spec[1].map(function (p) {
      var fig = document.createElement('figure');
      fig.className = 'jl-tpl-piece';
      fig.style.width = (p[2] / widest * 100).toFixed(2) + '%';
      var sheet = document.createElement('div');
      sheet.className = 'jl-tpl-sheet';
      sheet.style.aspectRatio = p[2] + ' / ' + p[3];
      ['art', 'white', 'emboss', 'die'].forEach(function (layer) {
        var img = document.createElement('img');
        img.src = TEMPLATE_DIR + p[0] + '-' + layer + (layer === 'die' ? '.svg' : '.webp') + TEMPLATE_V;
        img.alt = layer === 'art' ? 'VINYLPAC example ' + p[1].toLowerCase() + ' artwork for the ' + spec[0] + ' jar' : '';
        img.loading = 'lazy'; img.decoding = 'async';
        img.dataset.layer = layer;
        sheet.appendChild(img);
      });
      var cap = document.createElement('figcaption');
      var name = document.createElement('strong'); name.textContent = p[1];
      var size = document.createElement('span'); size.textContent = p[4];
      var pdf = document.createElement('a');
      pdf.className = 'jl-text-link'; pdf.href = TEMPLATE_DIR + p[0] + '.pdf' + TEMPLATE_V;
      pdf.download = 'VINYLPAC ' + spec[0] + ' ' + p[1].toLowerCase() + ' template.pdf';
      pdf.textContent = 'PDF ↓';
      pdf.setAttribute('aria-label', 'Download the ' + spec[0] + ' ' + p[1].toLowerCase() + ' template (PDF)');
      cap.append(name, size, pdf);
      fig.append(sheet, cap);
      return fig;
    }));
  }
  (function wireTemplateLayers() {
    var box = $('templates');
    if (!box) return;
    box.querySelectorAll('.jl-tpl-layers button').forEach(function (button) {
      button.addEventListener('click', function () {
        var on = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(on));
        box.classList.toggle('hide-' + button.dataset.layer, !on);
      });
    });
  })();
  // Waits for this jar's lid to screw shut (intro clip or live jar), then switches the Lid wrap on.
  var lidWrapTimer = null;
  function armLidWrap() {
    clearInterval(lidWrapTimer); lidWrapTimer = null;
    if (!ringAuto(state)) return;
    var target = state, started = performance.now(), sawOpen = false;
    var model = target.productId === 'black-4oz' ? 'black4oz' : 'saturn';
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    lidWrapTimer = setInterval(function () {
      if (state !== target || !ringAuto(target)) { clearInterval(lidWrapTimer); lidWrapTimer = null; return; }
      if (busy) return;
      var t = performance.now() - started, closed = false;
      var clip = window.VPStandin && window.VPStandin.state ? window.VPStandin.state().active : null;
      var live = window.VPJarPreview && window.VPJarPreview.introState ? window.VPJarPreview.introState() : null;
      var diag = window.jarArtworkDiagnostics ? window.jarArtworkDiagnostics() : null;
      if (clip && !clip.ended && String(clip.key).split('|')[1] === model && clip.playing) closed = clip.time >= LID_CLOSED_AT;
      else if (live && live.visible && diag && diag.jar === model) {
        if (live.introPending || live.lidT > 0 || live.lidTarget > 0) sawOpen = true;
        else closed = sawOpen || t > 1500;  // shut after its intro, or this jar showed without one
      } else closed = t > (still ? 400 : 5000);  // no 3D: the photo stage
      if (still && t > 400) closed = true;
      if (!closed) return;
      clearInterval(lidWrapTimer); lidWrapTimer = null;
      var ring = order.ringFor(target);
      if (!ring || !ring.available) return;
      target.ring = true;  // not ringChosen: the next visit opens at the base price again
      selectImage(); changed(true);
      var price = $('ring-price');
      price.classList.remove('jl-upcharge-added'); void price.offsetWidth; price.classList.add('jl-upcharge-added');
    }, 100);
  }
  function setBusy(value) {
    busy = value;
    $('detail').setAttribute('aria-busy', String(value));
    document.querySelectorAll('#jl-form input, #jl-form textarea, #jl-form button, #jl-products button, #jl-cancel-edit, #jl-gallery-views button').forEach(function (node) { node.disabled = value; });
    if (state) {
      $('emboss-field').disabled = $('emboss-field').hidden;
      var ring = order.ringFor(state); $('ring').disabled = value || ((!ring || !ring.available) && !state.ring);
      renderPrice();
    }
  }
  // A PNG/JPG/WebP/GIF/SVG data URL the page can show as it is.
  function isWebImage(original) { return /^data:image\/(png|jpeg|webp|gif|svg\+xml)[;,]/.test(original || ''); }
  function readFile(file) {
    return new Promise(function (resolve, reject) {
      var extension = file.name.split('.').pop().toLowerCase();
      var mime = {png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', svg: 'image/svg+xml', pdf: 'application/pdf'}[extension];
      if (!file.size) { reject(new Error('This file is empty. Choose it again.')); return; }
      var reader = new FileReader();
      var timer = setTimeout(function () { reader.abort(); reject(new Error('The file took too long to read. Try selecting it again.')); }, 30000);
      reader.onerror = reader.onabort = function () { clearTimeout(timer); reject(new Error('The file could not be read. Please select it again.')); };
      reader.onload = function () {
        clearTimeout(timer);
        var result = String(reader.result || '');
        var comma = result.indexOf(',');
        if (comma < 0) { reject(new Error('The original file could not be read.')); return; }
        var bytes;
        try { bytes = atob(result.slice(comma + 1, comma + 1 + 8192)); }
        catch (_) { reject(new Error('The original file could not be read.')); return; }
        // Josh 10/17: any other file (AI, PSD, EPS…) is kept as it is, with its own type.
        if (!mime) { resolve(window.VPArtFiles.dataUrl(result, file)); return; }
        var valid = mime === 'image/png' ? bytes.slice(0, 8) === '\x89PNG\r\n\x1a\n' : mime === 'image/jpeg' ? bytes.slice(0, 3) === '\xff\xd8\xff' : mime === 'application/pdf' ? bytes.indexOf('%PDF-') >= 0 : /<svg[\s>]/i.test(bytes);
        if (!valid) { reject(new Error('The file contents do not match its PNG, JPG, SVG, or PDF extension.')); return; }
        resolve('data:' + mime + ';base64,' + result.slice(comma + 1));
      };
      reader.readAsDataURL(file);
    });
  }
  var MAX_FILE = 20 * 1024 * 1024;
  async function addFiles(list) {
    if (busy) return;
    var incoming = Array.prototype.slice.call(list || []);
    if (!incoming.length) return;
    var productId = state.productId;
    var art = artworkFor(productId);
    var pieces = piecesFor(productId);
    var errors = [], jobs = [];
    message('artwork-error', ''); message('saved', ''); message('save-error', '');
    incoming.forEach(function (file) {
      if (file.size > MAX_FILE) { errors.push(file.name + ' is over 20 MB. Add to cart now and email it to info@vinylpac.us after checkout with your order number.'); return; }
      var slot = slotFor(file.name, art, pieces);
      if (slot.error) { errors.push(slot.error); return; }
      var piece = slot.piece;
      var previous = art[piece];
      cancelArtworkPreview(previous);
      if (previous && !previous.original) previous = previous.fallback;  // a pending file we replace: fall back to the last READY file there (Sol round 6)
      var pending = {name: file.name, reading: true, fallback: previous};
      art[piece] = pending;
      var where = function () { return pieces.filter(function (p) { return art[p] === pending; })[0]; };  // dropped if replaced or removed meanwhile
      jobs.push(readFile(file).then(function (original) {
        var at = where();
        if (at) art[at] = {name: file.name, original: original};
      }, function (error) {
        var at = where();
        if (!at) return;
        if (previous && previous.original) art[at] = previous; else delete art[at];
        errors.push(file.name + ': ' + error.message + (previous && previous.original ? ' Your previous file is unchanged.' : ''));
      }));
    });
    $('body-file').value = '';
    renderArtwork(); renderPrice();
    await Promise.all(jobs);
    if (state.productId !== productId) return;
    if (errors.length) message('artwork-error', errors.join(' '));
    if (pieces.some(function (piece) { return art[piece] && art[piece].original; })) setGallery('artwork');
    renderArtwork(); renderPrice();
  }
  function removeFile(piece) {
    if (busy) return;
    var art = artworkFor(state.productId);
    cancelArtworkPreview(art[piece]);
    delete art[piece];
    $('body-file').value = '';
    message('artwork-error', ''); renderArtwork(); changed(false);
  }
  // The tag on a file row moves that file to the next label (wrap → top → lid wrap); a file already there swaps back.
  function cyclePiece(piece) {
    if (busy) return;
    var art = artworkFor(state.productId);
    var pieces = piecesFor(state.productId);
    var next = pieces[(pieces.indexOf(piece) + 1) % pieces.length];
    if (next === piece || !art[piece] || art[piece].reading || (art[next] && art[next].reading)) return;
    cancelArtworkPreview(art[piece]); cancelArtworkPreview(art[next]);
    var moving = art[piece];
    if (art[next]) art[piece] = art[next]; else delete art[piece];
    art[next] = moving;
    message('artwork-error', ''); renderArtwork(); changed(false);
  }
  function artworkRecord(c) {
    var art = artworkFor(c.productId);
    var record = {};
    ['body', 'lid', 'ring'].forEach(function (piece) {
      var included = piece !== 'ring' || !!c.lidWrap;
      var original = included && art[piece] ? art[piece].original : null;
      artKeys[piece].forEach(function (key) { record[key] = original; });
    });
    return record;
  }
  function cartItem(c, q) {
    var product = productFor(c.productId);
    var source = product.variants.find(function (v) { return v.id === q.variantId; });
    var properties = {
      'Product Type': 'Jar labels', 'Jar': jarNames[c.productId], 'Product ID': c.productId,
      'Size': jarNames[c.productId], 'Finish': c.finish,
      'Emboss': c.emboss === 'No Embossing' ? 'Flat' : tierName(c.tier) + ' · ' + c.emboss,
      'Variant ID': q.variantId, 'Print Tier': c.tier, 'Finish Option': c.finish, 'Emboss Finish': c.emboss,
      'Quantity': String(c.qty) + ' sets', 'Included': 'Top sticker + ' + (isFiveMl(c.productId) ? 'perforated ' : '') + 'wrap label',
      'Top + Wrap / Jar': money(q.baseUnitCents), 'Volume Discount': Math.round(q.discountRate * 100) + '% (top + wrap only)',
      'Artwork': c.bodyFilename || 'Upload later',
      'Lid Wrap': c.lidWrap ? 'Included — ' + c.qty + ' lid wraps' : 'Not selected'
    };
    properties['Glass Jars'] = c.addJars ? q.jarCount + ' jars with lids · ' + q.jarCases + ' full ' + (isFiveMl(c.productId) ? 'pack' : 'case') + (q.jarCases === 1 ? '' : 's') : 'Labels only';
    properties['Application'] = c.application ? 'Applied to ' + c.qty + ' jars · ' + money(q.applicationUnitCents) + '/jar' : 'Self-application';
    if (c.addJars) {
      properties['Glass Product ID'] = q.jarProductId;
      properties['Glass Total'] = money(q.jarTotalCents);
      properties['Spare Jars'] = q.spareJars + ' unlabeled';
      c.fulfillment = {jarProductId: q.jarProductId, jarCaseSize: q.jarCaseSize, jarCases: q.jarCases, jarCount: q.jarCount, spareJars: q.spareJars, jarUnitCents: q.jarUnitCents, jarTotalCents: q.jarTotalCents, applicationUnitCents: q.applicationUnitCents, applicationTotalCents: q.applicationTotalCents, labelsTotalCents: q.labelsTotalCents};
    }
    if (c.application) properties['Application Total'] = money(q.applicationTotalCents);
    if (c.whiteInk) properties['White Ink'] = c.whiteInk;
    if (c.jarType) properties['Jar Type'] = c.jarType;
    if (c.notes.trim()) properties['Special Instructions'] = c.notes.trim();
    if (c.lidFilename) properties['Top Artwork'] = c.lidFilename;
    if (c.lidWrap) {
      properties['Lid Wrap Variant ID'] = q.ringVariantId;
      properties['Lid Wrap / Jar'] = money(q.ringUnitCents) + ' (not discounted)';
      if (c.ringFilename) properties['Lid Wrap Artwork'] = c.ringFilename;
    }
    return {
      name: product.name + (c.application ? ' — Ready to fill' : c.addJars ? ' — Labels + Glass' : ' — Top + Wrap'), cat: 'jar-labels', qty: c.qty,
      unitPrice: (q.totalCents / c.qty / 100).toFixed(10).replace(/0+$/, '').replace(/\.$/, ''), total: q.totalCents / 100,
      productId: c.productId, variantId: q.variantId, configuration: c,
      properties: Object.keys(properties).map(function (name) { return {name: name, value: String(properties[name])}; }),
      artworkFile: c.bodyFilename, lidArtworkFile: c.lidFilename, ringArtworkFile: c.ringFilename,
      // The cart thumbnail follows the line's Lid wrap choice (the 150ml renders carry lidWrap; photos don't).
      artworkThumb: '', thumbUrl: (product.images.find(function (image) { return typeof image.lidWrap !== 'boolean' || image.lidWrap === !!c.lidWrap; }) || product.images[0]).src,
      liveStoreUrl: source && !source.previewOnly && c.whiteInk !== 'No white' && !c.addJars && !c.application ? product.url + '?variant=' + encodeURIComponent(q.variantId) : ''
    };
  }
  function refreshCartUI() {
    try {
      var cart = window.VPProductCart.read();
      var badge = document.getElementById('cartBadge');
      if (badge) { badge.textContent = cart.length; badge.style.display = cart.length ? 'inline-flex' : 'none'; }
      if (typeof window.renderCartDrawer === 'function') window.renderCartDrawer();
    } catch (_) { /* A late fragment load must not change the durable save result. */ }
  }
  async function saveCart(event) {
    event.preventDefault();
    if (busy || editBlocked) return;
    // Josh 10/17: a 5ml add asks which jar first (Ceres and Eris are different dies); an edit already said.
    if (!editId && isFiveMl(state.productId) && openJarCheck()) return;
    return commitCart('');
  }
  async function commitCart(lead) {
    if (busy || editBlocked) return;
    message('save-error', ''); message('saved', '');
    var wasEditing = !!editId;
    try {
      if (anyReading()) throw new Error('Wait for your original files to finish loading.');
      if (joinNotes(state).length > NOTES_MAX) throw new Error('Your instructions are too long. Please keep "What should we emboss?" and Special instructions under ' + NOTES_MAX.toLocaleString('en-US') + ' characters together.');
      var c = configuration();
      var q = order.validate(c);
      if (!window.VPProductCart) throw new Error('Local cart storage could not load. Reload the page and try again.');
      var item = cartItem(c, q);
      var record = artworkRecord(c);
      setBusy(true);
      await window.VPProductCart.commit(item, record, editId);
      refreshCartUI();
      editId = null; editOriginal = null; editBlocked = false;
      $('edit-notice').hidden = true;
      message('saved', lead + (wasEditing ? 'Cart updated. Your original files and all selections are saved on this device.' : 'Added to your cart. Your original files and all selections are saved on this device.'));
      $('review').hidden = false;
    } catch (error) {
      message('save-error', 'Could not save these jar labels. ' + error.message);
    } finally { setBusy(false); }
  }
  // Josh 10/17: "a little pop up when you add 5ml jar labels to cart" that confirms the jar is a Miron 5ml Ceres
  // (non-CR) or Eris (CR), with a switch to the other one or a way to name their own jar ("My jar: …" goes in
  // Special instructions). His own exception to no-popups-on-site: a check at Add to cart, not a picker.
  var FIVE_ML_CHECK = [
    {id: 'miron-5ml-ceres', name: 'Miron 5ml Ceres', lid: 'Non-CR · standard screw lid'},
    {id: 'miron-5ml-eris', name: 'Miron 5ml Eris', lid: 'CR · child-resistant lid'}
  ];
  var jarCheck = null;
  function buildJarCheck() {
    var dialog = document.createElement('dialog');
    dialog.className = 'jl-jar-check';
    dialog.setAttribute('aria-labelledby', 'jl-jar-check-title');
    dialog.setAttribute('aria-describedby', 'jl-jar-check-lede');
    dialog.innerHTML = '<form method="dialog" class="jl-jar-check-card" tabindex="-1" novalidate>' +
      '<button type="button" class="jl-jar-check-close" data-close aria-label="Close">×</button>' +
      '<h2 id="jl-jar-check-title">Which 5ml jar are these for?</h2>' +
      '<p id="jl-jar-check-lede">Ceres and Eris labels are cut on different dies, so each only fits its own jar.</p>' +
      '<fieldset class="jl-jar-check-options"><legend class="jl-visually-hidden">Your jar</legend>' +
      FIVE_ML_CHECK.map(function (jar) {
        return '<label class="jl-jar-check-option"><input type="radio" name="jl-jar-check" value="' + jar.id + '">' +
          '<img src="' + jarThumbs[jar.id] + '" alt="" width="44" height="44"><span><strong>' + jar.name + '</strong><small>' + jar.lid + '</small></span></label>';
      }).join('') +
      '<label class="jl-jar-check-option" data-other><input type="radio" name="jl-jar-check" value="other">' +
      '<span class="jl-jar-check-icon" aria-hidden="true">?</span><span><strong>A different jar</strong><small>Tell us which; we confirm the fit on your proof</small></span></label></fieldset>' +
      '<div class="jl-jar-check-detail" hidden><label for="jl-jar-check-detail">Your jar</label><input id="jl-jar-check-detail" type="text" maxlength="120" autocomplete="off" placeholder="Brand, size and lid"></div>' +
      '<p class="jl-jar-check-note" hidden></p><p class="jl-error" role="alert" hidden></p>' +
      '<button type="submit" class="jl-primary btn-atc">Add to cart</button>' +
      '<button type="button" class="jl-jar-check-back" data-close>Go back</button></form>';
    document.body.appendChild(dialog);
    var form = dialog.querySelector('form'), detail = dialog.querySelector('#jl-jar-check-detail'), error = dialog.querySelector('.jl-error');
    dialog.querySelectorAll('[data-close]').forEach(function (button) { button.addEventListener('click', function () { dialog.close(); }); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });  // the backdrop
    dialog.addEventListener('change', function () { error.hidden = true; syncJarCheck(); });
    detail.addEventListener('input', function () { error.hidden = true; });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var pick = jarCheckPick(), lead = '';
      if (pick === 'other') {
        var jar = detail.value.trim();
        if (!jar) { error.textContent = 'Tell us which jar, or pick Ceres or Eris.'; error.hidden = false; detail.focus(); return; }
        var line = 'My jar: ' + jar;
        if (state.notes.split('\n').indexOf(line) === -1) state.notes = (state.notes.trim() ? state.notes.trim() + '\n' : '') + line;
        $('notes').value = state.notes;
      } else if (pick !== state.productId) { moveFiveMl(pick); lead = 'Switched to ' + order.fiveMlJarType(pick) + ' labels. '; }
      dialog.close();
      commitCart(lead);
    });
    return dialog;
  }
  function jarCheckPick() {
    var picked = jarCheck.querySelector('input[name="jl-jar-check"]:checked');
    return picked ? picked.value : state.productId;
  }
  // The same quantity the page lands on after a jar switch: a picked step follows the new packs, a typed one rounds up to them.
  function movedQty(toId) {
    var to = {productId: toId, addJars: state.addJars, jarType: order.fiveMlJarType(toId)};
    var index = state.qtyCustom ? -1 : presetIndex(state.qty, state.productId);
    return index === -1 ? wholeCases(to, state.qty) : presetsFor(to)[index];
  }
  function syncJarCheck() {
    var pick = jarCheckPick(), other = pick === 'other', moving = !other && pick !== state.productId;
    var name = other ? '' : order.fiveMlJarType(pick), note = '';
    jarCheck.querySelector('.jl-jar-check-detail').hidden = !other;
    // Labels alone cost the same on either jar; with Add the jars, packs of 95 vs 90 change the count and total.
    if (moving) {
      try {
        var c = configuration(), qty = movedQty(pick), now = order.quote(c);
        var then = order.quote(Object.assign({}, c, {productId: pick, jarType: name, qty: qty}));
        if (qty !== c.qty || then.totalCents !== now.totalCents) note = 'With ' + name + ' jars (packs of ' + then.jarCaseSize + '): ' + qty.toLocaleString('en-US') + ' sets · ' + money(then.totalCents) + '.';
      } catch (_) { /* The page shows any quantity problem once it switches. */ }
    }
    var noteNode = jarCheck.querySelector('.jl-jar-check-note');
    noteNode.textContent = note; noteNode.hidden = !note;
    jarCheck.querySelector('[type="submit"]').textContent = moving ? 'Switch to ' + name + ' and add to cart' : 'Add to cart';
  }
  // The order moves to the other 5ml product as it stands: options, quantity, notes and the artwork file.
  function moveFiveMl(toId) {
    var from = state, product = productFor(toId);
    var to = choices[toId] || (choices[toId] = defaults(product));
    ['tier', 'finish', 'emboss', 'qtyCustom', 'addJars', 'whiteInk', 'notes', 'embossWords', 'view'].forEach(function (key) { to[key] = from[key]; });
    to.qty = movedQty(toId);
    var art = artworkFor(from.productId);
    cancelArtworkPreview(art.body);  // the preview re-renders for the new product
    files[toId] = Object.assign({}, art);
    if (artworkViewed.has(from.productId)) artworkViewed.add(toId);
    renderProduct(product);
  }
  // True when the check opened; a browser without <dialog> adds straight away.
  function openJarCheck() {
    if (!jarCheck) jarCheck = buildJarCheck();
    if (typeof jarCheck.showModal !== 'function') return false;
    var current = jarCheck.querySelector('input[value="' + state.productId + '"]');
    current.checked = true;
    // Buying our glass already settles the jar, so only Ceres or Eris then.
    jarCheck.querySelector('[data-other]').hidden = !!state.addJars;
    jarCheck.querySelector('#jl-jar-check-detail').value = '';
    jarCheck.querySelector('.jl-error').hidden = true;
    syncJarCheck();
    jarCheck.showModal();
    jarCheck.querySelector('form').focus();  // no focus ring on the jar they already picked; Tab and arrows still reach it
    return true;
  }
  function stateFromConfiguration(c) {
    var said = splitNotes(c.notes || '', c);
    return Object.assign(defaults(productFor(c.productId)), {
      tier: c.tier, finish: c.finish, emboss: c.emboss, qty: c.qty,
      jarType: c.jarType || '', jarTypeDetails: c.jarTypeDetails || '', ring: !!c.lidWrap, ringChosen: true, notes: said.notes, embossWords: said.embossWords, view: 'artwork',
      whiteInk: c.whiteInk || NO_WHITE, addJars: c.addJars === true, application: c.application === true, qtyCustom: presetsFor(c).indexOf(c.qty) === -1
    });
  }
  function restoreArtwork(c, record) {
    var restored = {};
    var saved = c.artwork || {};
    ['body', 'lid', 'ring'].forEach(function (piece) {
      if (!saved[piece] && !c[piece + 'Filename']) return;
      var original = record && record[artKeys[piece][1]];
      if (typeof original !== 'string' || !/^data:[a-z0-9][a-z0-9!#$&^_.+-]*\/[a-z0-9][a-z0-9!#$&^_.+-]*;base64,/i.test(original)) {
        throw new Error('The saved ' + pieceNames[piece] + ' original could not be recovered.');
      }
      restored[piece] = {name: c[piece + 'Filename'], original: original};
    });
    return restored;
  }
  async function restoreEdit(id) {
    var serial = ++restoreSerial;
    editId = id; editBlocked = true; editOriginal = null;
    $('edit-notice').hidden = false;
    $('edit-text').textContent = 'Loading your saved cart item. The original stays in your cart.';
    setBusy(true);
    try {
      if (!window.VPProductCart) throw new Error('Local cart storage is unavailable.');
      var item = window.VPProductCart.read().find(function (entry) { return String(entry.id) === id; });
      if (!item || item.cat !== 'jar-labels' || !item.configuration) throw new Error('This jar-label item is no longer in your cart.');
      var c = JSON.parse(JSON.stringify(item.configuration));
      order.validate(c);
      editId = item.id;
      var record = await window.VPProductCart.getArtwork(item.id);
      if (serial !== restoreSerial) return;
      var art = restoreArtwork(c, record);
      editOriginal = {configuration: c, artwork: JSON.parse(JSON.stringify(art))};
      choices[c.productId] = stateFromConfiguration(c); files[c.productId] = art;
      editBlocked = false;
      renderProduct(productFor(c.productId));
      $('edit-text').textContent = 'Editing your cart item. The original stays in your cart until Update Cart succeeds.';
      message('save-error', '');
    } catch (error) {
      if (serial !== restoreSerial) return;
      $('edit-text').textContent = 'This edit could not be loaded. Your original cart item has not been changed.';
      message('save-error', error.message);
    } finally { if (serial === restoreSerial) setBusy(false); }
  }
  function cancelEdit() {
    if (busy) return;
    ++restoreSerial;
    if (editOriginal) {
      var c = editOriginal.configuration;
      choices[c.productId] = stateFromConfiguration(c);
      files[c.productId] = editOriginal.artwork;
      state = choices[c.productId];
    }
    editId = null; editOriginal = null; editBlocked = false;
    $('edit-notice').hidden = true;
    message('save-error', '');
    renderProduct(productFor(state.productId));
    message('saved', 'Edit cancelled. Your original cart item is unchanged.');
    $('review').hidden = false;
  }
  function restoreChoices() {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { cached = null; }
    products.forEach(function (product) {
      var saved = cached && cached.choices && cached.choices[product.id];
      var target = defaults(product);
      if (saved && typeof saved === 'object') {
        ['tier', 'finish', 'emboss', 'jarType', 'jarTypeDetails', 'notes', 'embossWords', 'view', 'whiteInk'].forEach(function (key) { if (typeof saved[key] === 'string') target[key] = saved[key]; });
        if (Number.isSafeInteger(saved.qty)) target.qty = saved.qty;
        target.qtyCustom = saved.qtyCustom === true;
        target.addJars = saved.addJars === true; target.application = saved.application === true;
        if (Number.isSafeInteger(saved.image)) target.image = saved.image;
        // Only a Lid wrap the customer switched themselves comes back; older saves hold old defaults, not choices.
        if (cached.lidWrapChosen === true && saved.ringChosen === true && typeof saved.ring === 'boolean') { target.ring = saved.ring; target.ringChosen = true; }
      }
      var art = artworkFor(product.id);
      if (!['body', 'lid', 'ring'].some(function (piece) { return art[piece] && art[piece].original; })) target.view = 'photos';
      choices[product.id] = target;
    });
    var params = new URLSearchParams(location.search);
    // Links from before the 10/17 split: jar=miron-5ml + jarType picks the matching 5ml product.
    if (params.get('jar') === 'miron-5ml') params.set('jar', params.get('jarType') === 'Eris' ? 'miron-5ml-eris' : 'miron-5ml-ceres');
    var product = productFor(params.get('jar')) || productFor(cached && cached.active) || products[0];
    var target = choices[product.id];
    var linkedVariant = product.variants.find(function (variant) { return variant.id === params.get('variant'); });
    if (linkedVariant && !params.has('tier') && !params.has('finish') && !params.has('emboss')) {
      target.tier = linkedVariant.options[0]; target.finish = linkedVariant.options[1]; target.emboss = linkedVariant.options[2];
    }
    ['tier', 'finish', 'emboss'].forEach(function (key) { if (params.has(key)) target[key] = params.get(key); });
    // White ink follows the link's finish: a metallic link without it means Spot white (links made before the
    // option); a Standard link leaves the hidden choice alone; a link that names no finish keeps the saved one.
    if (isMetallic(target.finish)) {
      if (params.has('whiteInk')) target.whiteInk = params.get('whiteInk');
      else if (params.has('finish') || linkedVariant) target.whiteInk = NO_WHITE;
    }
    if (params.has('qty')) {
      target.qty = /^\d+$/.test(params.get('qty')) ? Number(params.get('qty')) : NaN;
      target.qtyCustom = presetIndex(target.qty, target.productId) === -1;
    }
    ['addJars', 'application'].forEach(function (key) { if (params.has(key)) target[key] = params.get(key) === '1'; });
    if (params.has('lidWrap')) { target.ring = params.get('lidWrap') === '1'; target.ringChosen = true; }
    else if (params.get('ring') === '1') { target.ring = true; target.ringChosen = true; }
    editId = params.get('edit');
    renderProduct(product);
    if (editId) restoreEdit(editId);
  }

  products.forEach(function (product) {
    var button = makeButton('jl-product', '', function () {
      message('save-error', ''); message('artwork-error', ''); message('saved', ''); $('review').hidden = true;
      renderProduct(product);
    });
    button.dataset.jar = product.id;
    var image = document.createElement('img'); image.src = jarThumbs[product.id] || product.images[0].src; image.alt = ''; image.width = 28; image.height = 28;
    var label = document.createElement('span'); label.textContent = jarNames[product.id];
    button.append(image, label); $('products').appendChild(button);
  });
  buildQuantity();
  function toggleQuantity() { if (!busy) { quantityOpen = !quantityOpen; renderPrice(); } }
  $('qty-trigger').addEventListener('click', toggleQuantity);
  document.querySelector('.jl-qty-head').addEventListener('click', function (event) { if (!event.target.closest('button')) toggleQuantity(); });
  $('qty-panel').addEventListener('keydown', function (event) { if (event.key === 'Escape' || event.key === 'Enter') { event.preventDefault(); quantityOpen = false; renderPrice(); $('qty-trigger').focus({preventScroll: true}); } });
  // Adding jars locks a typed quantity to whole cases (rounded up); picked steps follow the case ladder in renderPrice.
  function lockToCases() {
    if (!state.addJars || !state.qtyCustom || !Number.isSafeInteger(state.qty)) return;
    var cased = wholeCases(state, state.qty);
    if (cased !== state.qty) { state.qty = cased; $('qty').value = cased; }  // the box shows the case count even while focused
  }
  $('add-jars').addEventListener('change', function () { state.addJars = $('add-jars').checked; if (!state.addJars) state.application = false; lockToCases(); changed(false); });
  $('application').addEventListener('change', function () { state.application = $('application').checked; if (state.application) state.addJars = true; lockToCases(); changed(false); });
  $('gallery-views').querySelectorAll('button').forEach(function (button) { button.addEventListener('click', function () { if (!busy) setGallery(button.dataset.view); }); });
  $('qty').addEventListener('input', function () { state.qty = $('qty').value === '' ? NaN : Number($('qty').value); state.qtyCustom = true; changed(false); });
  $('notes').addEventListener('input', function () { state.notes = $('notes').value; changed(false); });
  $('emboss-words').addEventListener('input', function () { state.embossWords = $('emboss-words').value; changed(false); });
  $('ring').addEventListener('change', function () { state.ring = $('ring').checked; state.ringChosen = true; selectImage(); changed(true); });
  $('body-file').addEventListener('change', function (event) { addFiles(event.target.files); });
  (function wireDropZone() {
    var zone = $('body-upload');
    zone.addEventListener('dragover', function (event) { event.preventDefault(); if (!busy) zone.classList.add('dragover'); });
    zone.addEventListener('dragleave', function () { zone.classList.remove('dragover'); });
    zone.addEventListener('drop', function (event) {
      event.preventDefault(); zone.classList.remove('dragover');
      addFiles(event.dataTransfer.files);
    });
  })();
  ['body', 'lid', 'ring'].forEach(function (piece) {
    $(piece + '-preview').addEventListener('error', function () {
      $(piece + '-preview').hidden = true;
      $(piece + '-preview-note').hidden = false;
      $(piece + '-preview-note').textContent = 'Original file retained. A flat preview is not available for this file.';
    });
  });
  $('form').addEventListener('submit', saveCart);
  $('cancel-edit').addEventListener('click', cancelEdit);
  $('review').addEventListener('click', function () {
    if (typeof window.openCartDrawer === 'function') window.openCartDrawer(); else location.href = "/?view=configurator&openCart=1";
  });
  $('order').addEventListener('click', function (event) { if ($('order').getAttribute('aria-disabled') === 'true') event.preventDefault(); });
  window.addEventListener('popstate', function () {
    if (busy) { persist(); return; }
    ++restoreSerial; editOriginal = null; editBlocked = false;
    $('edit-notice').hidden = true; restoreChoices();
  });
  restoreChoices();
  $('detail').hidden = false; $('load-error').hidden = true;
}());
